class TabBox extends HTMLElement {
  connectedCallback() {
    this.tabButtons = this.querySelectorAll('tab-list button[type="button"]');
    this.tabPanels = this.querySelectorAll('tab-panel');

    this.tabButtons.forEach((tabItem) => {
      tabItem.addEventListener('click', () => {
        this.handleTabClick(tabItem);
      });
    });
  }

  handleTabClick(clickedButton) {
    // Get the panel ID from the clicked button's aria-controls attribute
    const panelId = clickedButton.getAttribute('aria-controls');
    if (!panelId) return;

    // Find the corresponding panel
    const activePanel = this.querySelector(`#${panelId}`);
    if (!activePanel) return;

    // Update all buttons
    this.tabButtons.forEach((tabButton) => {
      const isActive = tabButton === clickedButton;
      tabButton.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tabButton.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    // Hide all panels except the active one
    this.tabPanels.forEach((panel) => {
      const isActive = panel === activePanel;
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', 'true');
      }
    });
  }
}

customElements.define('tab-box', TabBox);
